<template>
    <div class="onboarding-container clearfix login-container"
    :class="{pageContainer: authToken}"
    >
        <router-link v-if="authToken" to="/account/account-settings" class="back-to-outfit gray-bottom-border">
            <div class="wtw-container">
                <span class="stay-black">Back to Account Settings</span>
            </div>
        </router-link>
        <logo v-if="!authToken"></logo>
        <div class="wtw-container small center">
            <form class="wtw-form">
                <h3 class="text-center">Reset Password</h3>

                <div class="input-container">
                    <input v-if="!successMessage"
                           v-model="user.password"
                           v-validate="'required'"
                           type="password" name="password"
                           placeholder="Password"
                            @input="clearErrors"
                    />
                </div>

                <div class="input-container">
                    <input v-if="!successMessage" v-model="passwordConfirm" @input="doPasswordsMatch" type="password"
                           name="passwordConfirm"
                           placeholder="Confirm Password"
                    />
                    <span v-show="passwordMatchError" class="error-message">{{ passwordMatchError }}</span>
                    <span v-show="errorMessage" class="error-message">{{ errorMessage }}</span>
                    <div v-show="successMessage" class="wtw-panel">
                        <p>
                            {{ successMessage }}
                        </p>
                        <p>
                            <router-link class="stay-pink" to="/account/login">Click Here to Log In</router-link>
                        </p>
                    </div>
                </div>
                <transition-group name="fade">
                    <div v-if="!dataSending && !successMessage"
                         @click.stop="resetPassword(user)"
                         class="button pink"
                         key="1">
                        Reset Password
                    </div>
                    <div v-if="dataSending"
                         class="loading-overlay"
                         key="2">
                        <loader></loader>
                    </div>
                </transition-group>
            </form>
        </div>

        <div @click.stop="$router.go(-1)" class="back-button">
            Back
        </div>
    </div>
</template>

<script>

    import Loader from '../common/loader.vue';
    import {mapGetters} from 'vuex';
    import Logo from '../header/logo.vue';

    export default{
        data(){
            return {
                user: {
                    password: null,
                    code: null,
                },
                passwordConfirm: null,
                passwordMatchError: null,
                errorMessage: null,
                successMessage: null,
                dataSending: false,
            }
        },
        computed: {
                ...mapGetters({
                    authToken: 'auth/getAuthToken'
                })
        },
        components: {Loader, Logo},
        methods: {
            doPasswordsMatch(){
                this.clearErrors();
                if (this.user.password !== this.passwordConfirm) {
                    this.passwordMatchError = "Passwords must match."
                    return false;
                } else {
                    this.passwordMatchError = null
                    return true;
                }
            },
            resetPassword(){
                if(this.doPasswordsMatch()) {
                    this.dataSending = true;
                    this.clearErrors();
                    this.$store.dispatch('auth/resetPassword', this.user)
                            .then(response => {
                                this.dataSending = false;
                                this.errorMessage = null;
                                if (this.user.code) {
                                    this.successMessage = response;
                                }
                                this.clearForm();
                            })
                            .catch(response => {
                                this.dataSending = false;
                                this.errorMessage = response;
                            });
                }
            },
            clearForm(){
                this.user.password = this.user.code = this.passwordConfirm = null;
            },
            clearErrors(){
                this.errorMessage = null;
            }
        },
        mounted(){
            if (this.$route.query.code) {
                this.user.code = this.$route.query.code;
            }
        }
    }
</script>